import React from 'react'
import styled from 'styled-components/macro'

const DividerBox = styled.hr`
  border: 0.5px solid #ebedf3;
  width: 100%;
`

export const Divider = () => <DividerBox />
